import { useNavigate } from 'react-router-dom';
import SearchBar from '../search-bar/search-bar';
import styles from './header.module.scss';
import Notifications from '../notifications/notifications';
import AccountMenu from '../account-menu/account-menu';
import React, { useContext, useEffect } from 'react';
import authService from '../../../services/auth.service';
import { localStorageService, STORAGE_KEY } from '../../../services/local-storage.service';
import Logo from '../../molecules/logo/logo';
import Button from 'components/atoms/button/button';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import MenuIcon from '@mui/icons-material/Menu';
import useDeviceType from 'custom-hooks/useDeviceType';
import { CommonContext } from 'contexts/commonContext';

function Header() {
  const navigate = useNavigate();
  const { showMenu, setShowMenu } = useContext(CommonContext);

  const { isDesktop } = useDeviceType();

  const isLoggedIn = authService.isLoggedIn();

  let user = undefined;

  let userJSONString = localStorageService.getItem(STORAGE_KEY.USER);
  if (userJSONString !== null) {
    try {
      user = JSON.parse(userJSONString);
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }

  useEffect(() => {
    userJSONString = localStorageService.getItem(STORAGE_KEY.USER);
    if (userJSONString !== null) {
      try {
        user = JSON.parse(userJSONString);
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    }
  }, []);

  const handleClickLogin = () => {
    navigate('/login');
  };

  const handleClickMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <div className={styles.header}>
        <Button type={'base'} onClick={handleClickMenu} className={styles.navButton}>
          <MenuIcon />
        </Button>
        <Logo />
        {isDesktop && (
          <div className={styles.searchbarWrapper}>
            <SearchBar />
          </div>
        )}

        {isLoggedIn ? (
          <div className={styles.actions}>
            {isDesktop && <Notifications />}
          
            <div className={styles['profile']}>
              <AccountMenu  />
            </div>
          </div>
        ) : (
          <Button
            type={isDesktop ? 'primaryOutline' : 'base'}
            onClick={handleClickLogin}
            className={styles.login}
          >
            {isDesktop ? 'Log in' : <Person2OutlinedIcon />}
          </Button>
        )}
      </div>
    </>
  );
}

export default Header;
